<template>
  <div class="formula-mix-nutrition">
    <a-tabs size="small" :activeKey="activeTab" @change="handleTabChange">
      <a-tab-pane key="total" tab="合计">
        <resize-table
          :scroll="{ x: 600, y: height - 100 }"
          :columns="totalNutritionColumns"
          :loading="totalListLoading"
          :data-source="totalList"
          :row-key="record => record.nutritionId"
          :pagination="false"
          bordered
        >
          <span slot="customTitle"><a-icon @click="fixedColTotal" type="pushpin" :theme="filledTotal ? 'filled' : 'outlined'" /> 指标名称</span>
          <template slot="nutritionName" slot-scope="text, record">
            {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
          </template>
          <template slot="nutritionValue" slot-scope="text, record">
            {{ text | numberFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 2) }}
          </template>
          <template slot="productContent" slot-scope="text, record">
            {{ text | numberFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 2) }}
          </template>
          <template v-for="twin in ['minApply', 'maxApply', 'cost']" :slot="twin" slot-scope="text">
            <span :key="twin">{{ text || text === 0 ? Number(text).toFixed(3) : '' }}</span>
          </template>
          <template v-for="col in ['minValue', 'maxValue']" :slot="col" slot-scope="text, record">
            <cell-editor
              :key="col"
              :len="len(record)"
              :item="record"
              :name="col"
              @blur="target => itemUpdateTotal(target)"
              :text="text"
              :actions="update"
            />
          </template>
        </resize-table>
      </a-tab-pane>
      <a-tab-pane key="supplement" tab="补充料">
        <resize-table
          :scroll="{ x: 600, y: height - 100 }"
          :columns="nutritionColumns"
          :loading="supplementListLoading"
          :data-source="supplementList"
          :row-key="record => record.nutritionId"
          :pagination="false"
          bordered
        >
          <span slot="customTitle"><a-icon @click="fixedColSupplement" type="pushpin" :theme="filledSupplement ? 'filled' : 'outlined'" /> 指标名称</span>
          <template slot="nutritionName" slot-scope="text, record">
            {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
          </template>
          <template slot="nutritionValue" slot-scope="text, record">
            {{ text | numberFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 2) }}
          </template>
          <template slot="productContent" slot-scope="text, record">
            {{ text | numberFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 2) }}
          </template>
          <template v-for="twin in ['minApply', 'maxApply', 'cost']" :slot="twin" slot-scope="text">
            <span :key="twin">{{ text || text === 0 ? Number(text).toFixed(3) : '' }}</span>
          </template>
          <template v-for="col in ['minValue', 'maxValue']" :slot="col" slot-scope="text, record">
            <cell-editor
              :key="col"
              :len="len(record)"
              :item="record"
              :name="col"
              @blur="target => itemUpdateSupplement(target)"
              :text="text"
              :actions="update"
            />
          </template>
        </resize-table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import CellEditor from '../editor/CellEditor.vue'
import { formulaMixins } from '../unitls'
import formulaNutritionColumns from './formulaNutritionColumns.js'

export default {
  mixins: [formulaMixins],
  components: { CellEditor },
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      activeTab: 'total',
      totalList: [],
      supplementList: [],
      totalListLoading: false,
      supplementListLoading: false,
      filledTotal: true,
      filledSupplement: true,
      cacheTotalData: [],
      cacheSupplementData: [],
      nutritionColumns: formulaNutritionColumns,
      // 合计tab的列配置（排除产品列）
      totalNutritionColumns: formulaNutritionColumns.filter(col => col.dataIndex !== 'productContent'),
      filterType: 0
    }
  },
  watch: {
    formula(item) {
      if (item.id) this.getList({ taskFormulaId: item.id })
    },
    resNut(val) {
      if (val) this.getList()
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleTabChange(key) {
      this.activeTab = key
    },
    len(record) {
      return record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 2
    },
    fixedColTotal(e) {
      this.filledTotal = !this.filledTotal
      e = e || window.event
      if (e.stopPropagation) {
        e.stopPropagation()
      } else {
        e.cancelBubble = true
      }
    },
    fixedColSupplement(e) {
      this.filledSupplement = !this.filledSupplement
      e = e || window.event
      if (e.stopPropagation) {
        e.stopPropagation()
      } else {
        e.cancelBubble = true
      }
    },
    itemUpdateTotal(item) {
      // 使用唯一标识来精确匹配和更新
      const target = this.cacheTotalData.find(i => i._uniqueId === item._uniqueId)
      if (target) {
        Object.assign(target, item)
        // 同步更新显示列表
        const displayTarget = this.totalList.find(i => i._uniqueId === item._uniqueId)
        if (displayTarget) {
          Object.assign(displayTarget, item)
          this.$set(this, 'totalList', [...this.totalList])
        }
      }
    },
    itemUpdateSupplement(item) {
      // 使用唯一标识来精确匹配和更新
      const target = this.cacheSupplementData.find(i => i._uniqueId === item._uniqueId)
      if (target) {
        Object.assign(target, item)
        // 同步更新显示列表
        const displayTarget = this.supplementList.find(i => i._uniqueId === item._uniqueId)
        if (displayTarget) {
          Object.assign(displayTarget, item)
          this.$set(this, 'supplementList', [...this.supplementList])
        }
      }
    },
    async update(data) {
      // 根据是否有_uniqueId前缀判断是合计还是补充料
      const isTotal = data._uniqueId && data._uniqueId.startsWith('total_')
      const action = isTotal 
        ? this.formulataskformulanutritionMixUpdate  // 合计使用新接口
        : this.formulataskformulanutritionUpdate      // 补充料使用原接口
      
      return this.fetchPost({
        showMessage: false,
        actions: action,
        data: data
      })
    },
    filterNutrition(val) {
      // 兼容原有调用，仅按指标分类筛选
      this.filterType = val
      this.filterNutritionData(val, false)
    },
    // 统一过滤方法：支持指标分类 + 产品对比差异项
    filterNutritionData(nutType, showDiffOnly) {
      this.filterType = nutType
      let totalList = JSON.parse(JSON.stringify(this.cacheTotalData));
      let supplementList = JSON.parse(JSON.stringify(this.cacheSupplementData));

      // 第一步：按指标分类筛选
      let filterAction = null
      if (nutType == 1) filterAction = i => i.nutritionValue > 0 || i.nutritionValue < 0
      if (nutType == 2) filterAction = i => i.minValue != null || i.maxValue != null || i.minLimitValue != null || i.maxLimitValue != null

      if (filterAction) {
        totalList = totalList.filter(filterAction)
        supplementList = supplementList.filter(filterAction)
      }

      // 第二步：按产品对比差异项筛选（基于页面显示值比较，精度与 numberFixed 过滤器一致）
      if (showDiffOnly) {
        supplementList = supplementList.filter(i => {
          const len = (i.unit === 'MJ' || i.unit === 'Kcal') ? 0 : 2;
          const nutVal = (i.nutritionValue != null && i.nutritionValue !== '') ? Number(i.nutritionValue).toFixed(len) : '';
          const prodVal = (i.productContent != null && i.productContent !== '') ? Number(i.productContent).toFixed(len) : '';
          return nutVal !== prodVal;
        });
      }

      this.totalList = totalList;
      this.supplementList = supplementList;
    },
    async getList(arg = {}) {
      // 合计数据
      let totalRes = await this.fetchGet({
        actions: this.selectTaskFormulaNutritionMixByTaskFormulaId,
        loading: 'totalListLoading',
        data: {
          taskFormulaId: this.formula.id,
          size: 1000,
          ...arg
        }
      })
      let { success: totalSuccess, data: totalData } = totalRes || {}
      if (totalSuccess && totalData && totalData.records) {
        // 为合计数据添加唯一标识
        this.totalList = totalData.records.map((item, index) => ({
          ...item,
          _uniqueId: `total_${item.nutritionId}_${index}` // 合计唯一标识
        }))
        this.cacheTotalData = JSON.parse(JSON.stringify(this.totalList))
      }

      // 补充料数据（暂用原接口，后续替换）
      let supplementRes = await this.fetchGet({
        actions: this.selectTaskFormulaNutritionByTaskFormulaId,
        loading: 'supplementListLoading',
        data: {
          taskFormulaId: this.formula.id,
          size: 1000,
          ...arg
        }
      })
      let { success: supSuccess, data: supData } = supplementRes || {}
      if (supSuccess && supData && supData.records) {
        // 为补充料数据添加唯一标识
        this.supplementList = supData.records.map((item, index) => ({
          ...item,
          _uniqueId: `supplement_${item.nutritionId}_${index}` // 补充料唯一标识
        }))
        this.cacheSupplementData = JSON.parse(JSON.stringify(this.supplementList))
      }

      if (this.filterType) this.filterNutrition(this.filterType)
      return totalRes
    }
  }
}
</script>

<style lang="scss" scoped>
.formula-mix-nutrition {
  height: 100%;
  overflow: hidden;
}
</style>
